import React from 'react';

import PropertyLabel from 'src/components/PropertyLabel';
import { LeadLabelChip } from 'src/components/lead-labels/LeadLabelChips';
import { type ILabel, LabelType } from 'src/services/api/labels';

type Props = {
    label: ILabel;
};

/**
 * Renders a single label as the chip appropriate for its :class:`LabelType`.
 * This is the read-only display of a label, shared across the label-editing
 * modals so the lead-vs-property branch lives in one place.
 *
 * :param label: the label to render; its ``type`` selects the chip.
 */
export default function LabelChip({ label }: Props) {
    if (label.type === LabelType.LEAD) {
        return <LeadLabelChip label={label} size="body" />;
    }
    else {
        return <PropertyLabel label={label} />;
    }
}
